import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import { ArtworkView } from 'containers'
import { ARTWORK_ID_PARAM } from 'routes/params'
import * as routes from 'routes'

const Artwork = ({ match }) => (
  <Switch>
    <Route path={routes.artwork()} render={() => (
      <ArtworkView
        enableUnpublish
        id='artwork-view'
        artworkId={match.params[ARTWORK_ID_PARAM]}
      />
    )} />
    <Route path={routes.exportArtwork()} render={() => (
      <ArtworkView
        disableDelete
        disableDraft
        enablePublish
        enableUnpublish
        id='artwork-view'
        artworkId={match.params[ARTWORK_ID_PARAM]}
        backRoute={routes.exportArtworks}
      />
    )} />
  </Switch>
)

export default withRouter(Artwork)



// WEBPACK FOOTER //
// ./src/containers/Artwork/index.js